<template>
    <div class="minePage">
        <div class="mineTop">
            <div class="topNav">
                <van-icon name="arrow-left" color="#fff" size="30" @click="back()" />
                <van-icon name="chat-o" color="#fff" size="30" @click="toService()" />
            </div>
            <div class="userBox">
                <div>
                    <div>
                        <span class="van-ellipsis">{{ this.userInfo.username }}</span>
                        <img src="@/assets/v2/vip.png">
                    </div>
                    <div>
                        <span>{{ $t('gender') }}</span>
                        <span style="margin-left: 10px;">{{ userInfo.sex == 1 ? $t('male') : userInfo.sex == 2 ?
                            $t('female') : "--" }}</span>
                    </div>
                    <div>
                        <span>{{ $t('bankCardInformation') }}</span>
                        <span style="margin-left: 10px;">{{ isBank ? $t('have') : $t('notHave') }}</span>
                    </div>
                </div>
                <div>
                    <img src="@/assets/v2/avatar.jpg">
                </div>
            </div>
            <div class="mineMNain">
                <div class="yueBox">
                    <div>
                        <div>
                            <img src="@/assets/v2/yue.png">
                        </div>
                        <div>
                            <div>{{ this.userInfo.money || 0 }}</div>
                            <div>{{ $t('myActivityPoints') }}</div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="@/assets/v2/xyf.png">
                        </div>
                        <div>
                            <div>{{ this.userInfo.xinyufen || 0 }}</div>
                            <div>{{ $t('xinyufen') }}</div>
                        </div>
                    </div>
                </div>
                <div class="navCell">
                    <div @click="doWithdrawal()">
                        <div>
                            <img src="@/assets/v2/nav1.png">
                        </div>
                        <div>{{ $t('redeemPoints') }}</div>
                        <div>
                            <van-icon name="arrow" />
                        </div>
                    </div>
                    <div @click="toInfomation()">
                        <div>
                            <img src="@/assets/v2/nav2.png">
                        </div>
                        <div>{{ $t('basicInformation') }}</div>
                        <div>
                            <van-icon name="arrow" />
                        </div>
                    </div>
                    <div @click="toLoginPassword()">
                        <div>
                            <img src="@/assets/v2/nav3.png">
                        </div>
                        <div>{{ $t('loginPassword') }}</div>
                        <div>
                            <van-icon name="arrow" />
                        </div>
                    </div>
                    <div @click="$router.push({ path: '/GameRecord' })">
                        <div>
                            <img src="@/assets/v2/nav4.png">
                        </div>
                        <div>{{ $t('taskLog') }}</div>
                        <div>
                            <van-icon name="arrow" />
                        </div>
                    </div>
                    <div @click="toNotice()">
                        <div>
                            <img src="@/assets/v2/nav5.png">
                        </div>
                        <div>{{ $t('noticeAnnouncement') }}</div>
                        <div>
                            <van-icon name="arrow" />
                        </div>
                    </div>
                    <div @click="toService()">
                        <div>
                            <img src="@/assets/v2/nav6.png">
                        </div>
                        <div>{{ $t('onlineService') }}</div>
                        <div>
                            <van-icon name="arrow" />
                        </div>
                    </div>
                    <div @click="switchLanguage()">
                        <div>
                            <img src="@/assets/v2/nav7.png">
                        </div>
                        <div>{{ $t('switchLanguage') }}</div>
                        <div>
                            <van-icon name="arrow" />
                        </div>
                    </div>
                    <div @click="toStatement()">
                        <div>
                            <img src="@/assets/v2/sm.png">
                        </div>
                        <div>{{ $t('sm') }}</div>
                        <div>
                            <van-icon name="arrow" />
                        </div>
                    </div>
                </div>
                <div>
                    <van-button class="sign-out" type="primary" size="normal" @click="loginout()">
                        {{ $t('logOut') }}
                    </van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "mine",
    data() {
        return {
            userInfo: {},
            isBank: false,
        }
    },
    created() {
        if (localStorage.getItem('token')) {
            this.getUserInfo();
            this.getUserBankInfo();
        } else {
            this.$router.push({ path: '/Login' });
        }
    },
    methods: {
        getUserInfo() {
            this.$http({
                method: 'get',
                url: 'user_info'
            }).then(res => {
                if (res.code === 200) {
                    this.userInfo = res.data;
                    if (this.userInfo.status !== 1) {
                        this.$toast(this.$t('accountOffline'));
                        localStorage.removeItem("token");
                        this.$router.push({ path: '/Login' });
                    }
                } else if (res.code === 401) {
                    this.$toast(res.msg);
                }
            })
        },
        getUserBankInfo() {
            this.$http({
                method: 'get',
                url: 'user_get_bank'
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.is_bank) {
                        this.isBank = true;
                    } else {
                        this.isBank = false;
                    }
                } else if (res.code === 401) {
                    this.$toast(res.msg);
                }
            })
        },
        back() {
            this.$router.go(-1);
        },
        toService() {
            if (this.$i18n.locale == "ja") {
                return window.location.href = this.$store.getters.getBaseInfo.kefu;
            } else if (this.$i18n.locale == "ko") {
                return window.location.href = this.$store.getters.getBaseInfo.ko_kefu;
            }
        },
        loginout() {
            localStorage.removeItem("token");
            this.$router.push({ path: '/Login' });
        },
        doWithdrawal() {
            this.$http({
                method: 'get',
                url: 'user_get_bank'
            }).then(res => {
                if (res.data.is_bank) {
                    this.$router.push("withdraw");
                } else {
                    this.$router.push("Setbank");
                    this.$toast(this.$t('setUpBankCard'));
                }
            })
        },
        toInfomation() {
            this.$router.push({ path: '/Infomation' });
        },
        toLoginPassword() {
            this.$router.push({ path: '/SetLoginPassword' });
        },
        toNotice() {
            this.$router.push({ path: '/Notice' });
        },
        switchLanguage() {
            this.$router.push({ path: '/SwitchLanguage' });
        },
        toStatement() {
            this.$router.push({ path: '/Statement' });
        },
    }
}
</script>

<style lang="less" scoped>
.minePage {
    .mineTop {
        position: relative;
        padding: 150px 50px 80px;
        background: #1989fa;

        .topNav {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            padding: 20px 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .userBox {
            display: flex;
            align-items: center;
            justify-content: space-between;

            >div:nth-child(1) {
                color: #fff;
                max-width: 70%;

                >div:nth-child(1) {
                    display: flex;
                    align-items: center;
                    font-size: 50px;

                    img {
                        width: 50px;
                        margin-left: 5px;
                    }
                }

                >div:nth-child(2) {
                    margin: 5px 0 8px;
                    font-size: 14px;
                }

                >div:nth-child(3) {
                    font-size: 14px;
                }
            }

            >div:nth-child(2) {
                img {
                    width: 180px;
                    border-radius: 50%;
                }
            }
        }

        .mineMNain {
            border-radius: 20px 20px 0 0;
            background: #fff;
            padding: 50px;
            position: absolute;
            top: 90%;
            left: 0;
            width: 100%;

            .yueBox {
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #ebedf0;
                padding-bottom: 40px;
                margin-bottom: 40px;

                >div {
                    display: flex;
                    align-items: center;

                    >div:nth-child(1) {
                        margin-right: 15px;

                        img {
                            width: 60px;
                        }
                    }

                    >div:nth-child(2) {
                        >div:nth-child(1) {
                            font-size: 40px;
                            margin-bottom: 10px;
                        }

                        >div:nth-child(2) {
                            font-size: 14px;
                            color: #323233;
                        }
                    }
                }
            }

            .navCell {
                >div {
                    padding: 10px 0;
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #ebedf0;

                    >div:nth-child(1) {
                        margin-right: 10px;

                        img {
                            width: 50px;
                        }
                    }

                    >div:nth-child(3) {
                        margin-left: auto;
                    }
                }
            }

            .sign-out {
                margin: 80px 0 0 0;
                height: 90px;
                width: 100%;
                line-height: 90px;
                border-radius: 14px;
                color: #fff;
                font-size: 32px;
                font-weight: bolder;
                border: none;
                background: #1989fa;
            }
        }
    }
}
</style>